module.exports = __webpack_public_path__ + "files/d03f86ce19acae2a703683a6fa7292d2.png";